<template>
  <b-row no-gutters>
    <b-modal
      id="modal-rec-leave"
      ref="leaveRecModal"
      :hide-header="true"
      :hide-footer="true"
      :cancel-disabled="true"
      content-class="blah"
      dialog-class="rec-notify-wrapper"
      body-class="rec-notify-body"
    >
      <div class="rec-notify flex-row d-flex rounded">
        <div class="content rounded">
          <b-container
            fluid
            class="p-0">
            <b-row no-gutters>
              <span class="title">{{ $t("MEETING.LEAVE_MEETING") }}</span>
            </b-row>
            <b-row no-gutters>
              <span class="description">
                {{ $t("MEETING.LEAVE_RECORDING_NOTIFY") }}
              </span>
            </b-row>
            <b-row no-gutters>
              <b-col align="right">
                <b-btn
                  size="sm"
                  variant="secondary-light"
                  @click="$refs.leaveRecModal.hide()"
                >
                  {{ $t("MEETING.POPUP_NO") }}
                </b-btn>
                <b-btn
                  size="sm"
                  variant="primary-light"
                  @click="leaveMeeting()"
                >
                  {{ $t("MEETING.POPUP_YES") }}
                </b-btn>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </b-modal>
  </b-row>
</template>
  
  <script>

export default {
  name: "RecordingNotify",
  setup(props, context) {

    function leaveMeeting() {
      if (context.parent.$refs.meetingControls) {
        context.parent.$refs.meetingControls.toggleRecording();
        context.parent.$refs.meetingControls.exitMeeting(true);
      }
    }

    return {
        leaveMeeting,
    };
  },
};
</script>
  <style>
.rec-notify {
  min-height: 200px;
}

.rec-notify-wrapper {
  max-width: 605px;
  padding: 0;
}

.rec-notify .content {
  background-color: #ffffff;
  width: 100%;
  padding: 15px;
}

.rec-notify .content .title {
  font-weight: 600;
  font-size: 16px;
  color: #282828;
  margin-bottom: 8px;
}

.rec-notify .content .description {
  font-weight: 400;
  font-size: 14px;
  color: #282828;
  margin-bottom: 34px;
}

.rec-notify .custom-checkbox label {
  font-size: 14px;
}
.rec-notify label {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}

.testLink {
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #2166b2;
}
.pushedDown {
  margin-top: 32px;
}
.rec-notify .volume {
  margin-top: 4px;
  display: flex;
}
.rec-notify-body {
  min-height: 200px;
  background-color: #363636;
  padding: 0;
  border-radius: 0.25rem !important;
}

.rounded-top-left {
  border-top-left-radius: 0.25rem;
}
@media (min-width: 768px) {
  .rec-notify .content {
    padding: 32px 41px;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/RecordingNotify.vue